import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function DialogComponent({
  open,
  children,
  handleClose,
  title,
}) {
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title" style={{ alignSelf: 'center' }}>
        {title}
      </DialogTitle>
      <S.WrapperLog>{children}</S.WrapperLog>
    </Dialog>
  );
}
DialogComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
